import { Button, ICON_COLOR, IconButton } from '@zep-us/zus';
import { PenPaperIcon, QrcodeIcon, SquareStackIcon } from '@zep-us/zus/icons';
import { useTranslation } from 'next-i18next';
import { PlayFillIcon } from '@/icons/components/PlayFill';
export interface MobileOwnerCTAButtonsProps {
  onEnter: () => void;
  onShare: () => void;
  onDuplicate: () => void;
  onEdit: () => void;
}
export const MobileOwnerCTAButtons = ({
  onEnter,
  onShare,
  onDuplicate,
  onEdit
}: MobileOwnerCTAButtonsProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex w-full flex-row gap-xs" data-sentry-component="MobileOwnerCTAButtons" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
      <Button size="md" variant="contained" intent="gradient" onClick={onEnter} leftSlot={<PlayFillIcon size="sm" fill={ICON_COLOR.inverse} />} className="flex-1" data-sentry-element="Button" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        {t('global.enter.button')}
      </Button>

      <IconButton size="md" variant="contained" intent="alternative" onClick={onShare} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <QrcodeIcon size="sm" fill={ICON_COLOR.strong} data-sentry-element="QrcodeIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>

      <IconButton size="md" variant="outlined" intent="neutral" onClick={onDuplicate} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <SquareStackIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="SquareStackIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>

      <IconButton size="md" variant="outlined" intent="neutral" onClick={onEdit} data-sentry-element="IconButton" data-sentry-source-file="MobileOwnerCTAButtons.tsx">
        <PenPaperIcon size="sm" fill={ICON_COLOR.neutral} data-sentry-element="PenPaperIcon" data-sentry-source-file="MobileOwnerCTAButtons.tsx" />
      </IconButton>
    </div>;
};